import React, { useState, useEffect } from 'react';
import '../../styles/NotificationSystem.css';  // Nous allons créer ce fichier

const NotificationSystem = ({ message, type = 'info', duration = 3000, onClose }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(() => {
                setIsVisible(false);
                if (onClose) onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [duration, onClose]);

    if (!isVisible || !message) return null;

    const notificationClass = {
        success: 'is-success',
        error: 'is-danger',
        warning: 'is-warning',
        info: 'is-info'
    }[type] || 'is-info';

    return (
        <div 
            className={`notification ${notificationClass} custom-notification`}
            style={{
                position: 'fixed',
                top: '20px',
                right: '20px',
                minWidth: '300px',
                maxWidth: '500px',
                margin: '0.5rem'
            }}
        >
            <button 
                className="delete" 
                onClick={() => {
                    setIsVisible(false);
                    if (onClose) onClose();
                }}
            ></button>
            <div className="notification-content">
                {message}
            </div>
        </div>
    );
};

export default NotificationSystem;
